import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './components/common/ThemeProvider';
import router from './router';
import ReactGA from "react-ga4";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeFirebaseMessaging } from './utils/firebase';

// Initialize Firebase Analytics for web app
// Firebase configuration is now managed in utils/firebase.js
// The one here is just for analytics
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

ReactGA.initialize('G-49JPRCTPRW');

function App() {
  useEffect(() => {
    // Only initialize Firebase messaging if the user is logged in
    const token = localStorage.getItem('token');
    if (token) {
      initializeFirebaseMessaging().catch(error => {
        console.error('Failed to initialize Firebase messaging:', error);
      });
    }
  }, []);

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background text-foreground antialiased">
        <RouterProvider router={router} />
      </div>
    </ThemeProvider>
  );
}

export default App; 